import { Tooltip } from "../../Tooltip";
import { Input, InputProps } from "../Input";
import { Button, InputContainer, Text, Container } from "./styles";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { Flex } from "@chakra-ui/react";
interface Props extends InputProps {
  icon?: any;
  buttonText?: string;
  tooltipButtonText?: string;
  buttonfunction?: any;
  label?: string;
  disabled?: boolean;
  buttonDisabled?: boolean;
  width?: string;
  buttonFunction?: () => void;
  color?: any;
  sellerPaymentReceiptType?: string;
  infoTooltipLabel?: string;
}

export function InputButton({
  icon,
  buttonText,
  tooltipButtonText,
  label,
  buttonfunction,
  errors,
  disabled = false,
  buttonDisabled = false,
  buttonFunction,
  width,
  color,
  register,
  variant,
  infoTooltipLabel,
  labelColor = "var(--gray-400)",
  sellerPaymentReceiptType,
  ...rest
}: Props) {
  return (
    <Container>
      <Flex gap="4px"> 
      <Text color={labelColor} fontSize="12px">
        {label} 
      </Text>

      {infoTooltipLabel && sellerPaymentReceiptType === "TIMELINE" &&
        <Tooltip text={infoTooltipLabel}>
              <AiOutlineInfoCircle />
        </Tooltip>
        }
      </Flex>
      <InputContainer
        disabled={disabled} 
        className="inputContainer" 
        borderColor={errors ? "var(--red-700)" : "#C3CAD7"}
        bgColor="#EDF1F7"
        width={width}
      >
        <Input
          color={color}
          p={disabled ? "0" : "0 1rem"}
          fontSize="16px"
          isDisabled={disabled}
          _focus={{}}
          {...rest}
          register={register}
        />
        <Button 
          className="button"
          disabled={buttonDisabled}
          onClick={buttonFunction}
        >
          {icon && !buttonText && !disabled && (
            <Tooltip text={tooltipButtonText}>
              {icon}
            </Tooltip>
          )}
          {buttonText && !icon && !disabled && (
            <Tooltip text={tooltipButtonText}>
              {buttonText}
            </Tooltip>
          )}
        </Button>
      </InputContainer>
      {errors && (
        <Text color="var(--red-600)" fontSize=".8rem">
          {errors?.message}
        </Text>
      )}
    </Container>
  )
}